export default __webpack_public_path__ + "static/media/gq.f856315a.jpg";